import React from 'react';

const CorqTheme = {
  headerLogo: {
    src: '/themes/theme/corq/corq-logo.svg',
    alt: 'Corq Agency Logo',
    size: 35,
  },
  darkLogo: {
    src: '/themes/theme/corq/corq-logo.svg',
    alt: 'Corq Agency Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 90,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Corq Data',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="90" src="/themes/theme/corq/logo.png" alt="Corq Agency Logo" />
      <br /><br />
      <h3>Corq Agency Influencers</h3>
    </div>
  ),
  shareSite: 'https://share.corq.studio',
  hideMyInfluencers: true,
  hideShortlists: true,
  hideHomepage: true,
  disableHelpLinks: true,
};

export default CorqTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/corq.js
 **/